module.exports = __webpack_public_path__ + "img/logoOrientEst.08c025d8.svg";